import { publicConfig } from "./config";

const { MAIN_SITE_DOMAIN } = publicConfig;

const routes = {
	purchase: {
		configSubscription: `//${MAIN_SITE_DOMAIN}/ecommerce/buyLabLicense/`,
	},
	auth: {
		login: `//${MAIN_SITE_DOMAIN}/main/login`,
		logout: `//${MAIN_SITE_DOMAIN}/myaccount/sign-out`,
		exchange: "/auth/exchange",
	},
	myAccount: `//${MAIN_SITE_DOMAIN}/myaccount`,
	invoice: {
		pay: "/invoice/pay",
		invalid: "/invoice/invalid",
		success: "/invoice/pay-success",
	},
	payQuote: {
		index: "/invoice/view",
		invalidQuote: "/invoice/view/invalid",
		requestPOSuccess: "/invoice/view/success",
	},
	account: {
		subscription: {
			activations: "/account/subscription/activations",
			index: "/myaccount/subscription/",
		},
		entitlements: {
			activations: "/account/entitlements/activations",
		},
		preferences: "/account/preferences",
	},
	errors: {
		403: "/403",
		404: "/404",
		default: "/error",
	},
	external: {
		index: `//${MAIN_SITE_DOMAIN}/`,
		howToBuy: `//${MAIN_SITE_DOMAIN}/how-to-buy/`,
		support: `//${MAIN_SITE_DOMAIN}/support/`,
		cart: `//${MAIN_SITE_DOMAIN}/ecommerce/`,
		termsOfService: `//${MAIN_SITE_DOMAIN}/company/terms/`,
		privacyPolicy: `//${MAIN_SITE_DOMAIN}/company/privacy-policy/`,
		contactUs: `//${MAIN_SITE_DOMAIN}/contact-us/`,
		freeTrial: `//${MAIN_SITE_DOMAIN}/demos/`,
		customers: `//${MAIN_SITE_DOMAIN}/customers`,
		instat: `//${MAIN_SITE_DOMAIN}/scientific-software/instat/`,
		statMate: `//${MAIN_SITE_DOMAIN}/scientific-software/statmate/`,
		student: `//${MAIN_SITE_DOMAIN}/how-to-buy/student/`,
		professorCourseLicenses: `//${MAIN_SITE_DOMAIN}/free-course-licenses`,
		graphPadChina: "https://www.graphpad-prism.cn",
		quickCalcs: `//${MAIN_SITE_DOMAIN}/quickcalcs/`,
		statisticsGuide: `//${MAIN_SITE_DOMAIN}/guides/prism/latest/statistics/`,
		curveFittingGuide: `//${MAIN_SITE_DOMAIN}/guides/prism/latest/curve-fitting/`,
		prismAcademy: `//${MAIN_SITE_DOMAIN}/prism-academy`,
		prismUserGuide: `//${MAIN_SITE_DOMAIN}/guides/prism/latest/user-guide/`,
		about: `//${MAIN_SITE_DOMAIN}/company`,
		careers: "https://www.dotmatics.com/about-careers",
		portfolio: "https://www.dotmatics.com/portfolio",
		dotmatics: "https://www.dotmatics.com",
		contacts: `//${MAIN_SITE_DOMAIN}/company`,
		graphPadPrism: `//${MAIN_SITE_DOMAIN}/features`,
		resources: `//${MAIN_SITE_DOMAIN}/resources`,
		machineAccessTokenActivation: `//${MAIN_SITE_DOMAIN}/support/faq/machine-access-token-activation/`,
	},
	cloudEarlyAccess: "/cloud/success",
};
export default routes;
